import {
  ACTIONS_COL_WIDTH,
  ActionsDropdown,
  CombinedText,
  DarwinFlex,
  DMenuProps,
  DTableProps,
} from 'components/darwin-ui';
import Icon from 'components/darwin-ui/Icon';
import { TFunction } from 'i18next';
import { DataSourcesListView } from 'types/dataSourcesTypes';
import { ColumnAction } from '.';
import { renderDateCell } from '@darwin-ui';

export const getDataSourceColumns = (
  t: TFunction,
  actions: ColumnAction[],
  searchQuery: string
) => {
  const menuItems = (dataSource: DataSourcesListView): DMenuProps['items'] =>
    actions.map(action => ({
      key: action.key,
      label: (
        <DarwinFlex
          gap={8}
          align="center"
          onClick={() => action?.onClick?.(dataSource)}
        >
          <Icon
            name={action.name ? action.name : 'darwin-user'}
            size="sm"
            color="inherit"
          />
          {action.label}
        </DarwinFlex>
      ),
    }));

  const renderDateCol = renderDateCell;

  const columns: DTableProps<DataSourcesListView>['columns'] = [
    {
      title: t('data-sources.columns.name'),
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      render: (name: string) => (
        <CombinedText lines={1} text={name} highlight={searchQuery} />
      ),
    },
    {
      title: t('data-sources.columns.contact-name'),
      dataIndex: 'contactName',
      key: 'contactName',
      sorter: true,
      render: (contactName: string) => (
        <CombinedText lines={1} text={contactName} highlight={searchQuery} />
      ),
    },
    {
      title: t('data-sources.columns.contact-email'),
      dataIndex: 'contactEmail',
      key: 'contactEmail',
      sorter: true,
      render: (contactEmail: string) => (
        <CombinedText lines={1} text={contactEmail} highlight={searchQuery} />
      ),
      width: 200,
    },
    {
      title: t('created-at'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: true,
      render: renderDateCol,
      align: 'center',
      width: 160,
    },
    {
      title: t('updated-at'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      sorter: true,
      render: renderDateCol,
      align: 'center',
      width: 160,
    },
    {
      dataIndex: 'actions',
      key: 'actions',
      fixed: 'right',
      align: 'center',
      render: (_: any, dataSource: DataSourcesListView) => (
        <ActionsDropdown item={dataSource} getMenuItems={menuItems} />
      ),
      width: ACTIONS_COL_WIDTH,
    },
  ];

  return columns;
};
